import { Directive, ElementRef, HostBinding, Input, OnChanges, SimpleChanges } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';

import { SKIP_AUTH } from '~core/interceptors/header.interceptor';

@Directive({
	selector: '[appInlineSvg]',
})
export class InlineSvgDirective implements OnChanges {
	@Input() appInlineSvg = '';

	@HostBinding('style.display') display = 'contents';

	private static cache = new Map<string, string>();

	constructor(private el: ElementRef<HTMLElement>, private http: HttpClient) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (!('appInlineSvg' in changes)) return;
		const url = this.appInlineSvg;
		if (!url) {
			this.el.nativeElement.innerHTML = '';
			return;
		}
		const cached = InlineSvgDirective.cache.get(url);
		if (cached !== undefined) {
			this.render(url, cached);
			return;
		}
		this.http
			.get(url, { responseType: 'text', context: new HttpContext().set(SKIP_AUTH, true) })
			.subscribe((markup) => {
				InlineSvgDirective.cache.set(url, markup);
				this.render(url, markup);
			});
	}

	private render(requestedUrl: string, markup: string): void {
		if (this.appInlineSvg !== requestedUrl) return;
		this.el.nativeElement.innerHTML = markup;
	}
}
